import React from 'react';
import CustomInput from '../../CustomInput';

export default function UrlsDataInputs({ flag, onChange, data, errors }) {
    return (
        <>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`web_site_url_${flag}`}
                    placeholder="Enter Web site URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].web_site_url}
                    labelText="Web site"
                    width="100%"
                    errorText={
                        errors?.[`countries_localizations.${flag}.web_site_url`]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`terms_conditions_url_${flag}`}
                    placeholder={`Enter Terms & Conditions URL`}
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].terms_conditions_url}
                    labelText={`Terms & Conditions`}
                    width="100%"
                    errorText={
                        errors?.[
                            `countries_localizations.${flag}.terms_conditions_url`
                        ]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`support_page_url_${flag}`}
                    placeholder="Enter Support page URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].support_page_url}
                    labelText="Support page"
                    width="100%"
                    errorText={
                        errors?.[
                            `countries_localizations.${flag}.support_page_url`
                        ]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`blog_page_url_${flag}`}
                    placeholder="Enter Blog page URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].blog_page_url}
                    labelText="Blog page"
                    width="100%"
                    errorText={
                        errors?.[
                            `countries_localizations.${flag}.blog_page_url`
                        ]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`privacy_policy_url_${flag}`}
                    placeholder="Enter Privacy Policy URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].privacy_policy_url}
                    labelText="Privacy Policy"
                    width="100%"
                    errorText={
                        errors?.[
                            `countries_localizations.${flag}.privacy_policy_url`
                        ]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`web_app_url_${flag}`}
                    placeholder="Enter Web App URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].web_app_url}
                    labelText="Web App"
                    width="100%"
                    errorText={
                        errors?.[`countries_localizations.${flag}.web_app_url`]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`crm_url_${flag}`}
                    placeholder="Enter CRM URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].crm_url}
                    labelText="CRM"
                    width="100%"
                    errorText={
                        errors?.[`countries_localizations.${flag}.crm_url`]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`facebook_url_${flag}`}
                    placeholder="Enter Facebook URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].facebook_url}
                    labelText="Facebook"
                    width="100%"
                    errorText={
                        errors?.[`countries_localizations.${flag}.facebook_url`]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`app_store_url_${flag}`}
                    placeholder="Enter App Store URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].app_store_url}
                    labelText="App Store"
                    width="100%"
                    errorText={
                        errors?.[
                            `countries_localizations.${flag}.app_store_url`
                        ]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`google_play_url_${flag}`}
                    placeholder="Enter Google Play URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].google_play_url}
                    labelText="Google Play"
                    width="100%"
                    errorText={
                        errors?.[
                            `countries_localizations.${flag}.google_play_url`
                        ]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`twitter_url_${flag}`}
                    placeholder="Enter Twitter URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].twitter_url}
                    labelText="Twitter"
                    width="100%"
                    errorText={
                        errors?.[`countries_localizations.${flag}.twitter_url`]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`linkedIn_url_${flag}`}
                    placeholder="Enter LinkedIn URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].linkedIn_url}
                    labelText="LinkedIn"
                    width="100%"
                    errorText={
                        errors?.[`countries_localizations.${flag}.linkedIn_url`]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`contact_us_url_${flag}`}
                    placeholder="Enter Contact us URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].contact_us_url}
                    labelText="Contact us URL"
                    width="100%"
                    errorText={
                        errors?.[
                            `countries_localizations.${flag}.contact_us_url`
                        ]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`contact_us_email_${flag}`}
                    placeholder="Enter Contact us email"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].contact_us_email}
                    labelText="Contact us email"
                    width="100%"
                    errorText={
                        errors?.[
                            `countries_localizations.${flag}.contact_us_email`
                        ]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`instagram_url_${flag}`}
                    placeholder="Enter Instagram URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].instagram_url}
                    labelText="Instagram"
                    width="100%"
                    errorText={
                        errors?.[
                            `countries_localizations.${flag}.instagram_url`
                        ]
                    }
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`youtube_url_${flag}`}
                    placeholder="Enter Youtube URL"
                    onInputChange={(e) => onChange(e, flag)}
                    inputValue={data[flag].youtube_url}
                    labelText="Youtube"
                    width="100%"
                    errorText={
                        errors?.[`countries_localizations.${flag}.youtube_url`]
                    }
                />
            </div>
        </>
    );
}
